/* Duskhaven floating back-to-top button (2026-10-21, draft 5.8). See assets/dh-totop.css. Not loaded on product pages.
 * The page may scroll on the window or inside .page-wrapper, so both are watched (scroll events are caught on the capture
 * phase) and both are sent to the top. After the scroll, focus moves to the main content so keyboard users land there too. */
(function () {
  if (window.__dhToTop) return;
  window.__dhToTop = true;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 11.5 12 6l5.5 5.5"/><path d="M6.5 17.5 12 12l5.5 5.5"/></svg>';
  function reduce() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function wrap() { return document.querySelector('.page-wrapper'); }
  function scrolled() {
    var w = wrap();
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, w ? w.scrollTop : 0);
  }
  function toTop() {
    var behavior = reduce() ? 'auto' : 'smooth';
    var w = wrap();
    if (w && w.scrollTop > 0) w.scrollTo({ top: 0, behavior: behavior });
    window.scrollTo({ top: 0, behavior: behavior });
    var main = document.querySelector('main, #MainContent, [role="main"]');
    if (main) {
      if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
      setTimeout(function () { try { main.focus({ preventScroll: true }); } catch (e) {} }, behavior === 'smooth' ? 600 : 0);
    }
  }
  function start() {
    if (document.querySelector('.dh-totop')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dh-totop';
    b.setAttribute('aria-label', 'Back to top');
    b.title = 'Back to top';
    b.tabIndex = -1;
    b.innerHTML = ICON;
    b.addEventListener('click', toTop);
    document.body.appendChild(b);
    var tick = false, on = null;
    function update() {
      tick = false;
      var show = scrolled() > window.innerHeight * 0.8;
      if (show === on) return;
      on = show;
      b.classList.toggle('is-on', show);
      b.tabIndex = show ? 0 : -1;
    }
    document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { capture: true, passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
